import { useAtom } from 'jotai'
import React from 'react'

import { surveyFilterAtom } from '~/atoms'
import { SurveyFilterInformation } from '~/components/features/SurveyFilterInformation'
import { useSampleSize } from '~/hooks/useSampleSize'

import { useSetSurveyFilterFromLocalStorageV1 } from '../hooks/useSetSurveyFilterFromLocalStorageV1'

export type HeaderContentSurveyProps = {
  className?: string
  surveyId: string
}

export const HeaderContentSurvey = ({
  className,
  surveyId,
}: HeaderContentSurveyProps) => {
  const [surveyFilter, setSurveyFilter] = useAtom(surveyFilterAtom)
  const sampleSize = useSampleSize()

  const setSurveyFilterFromLocalStorageV1 =
    useSetSurveyFilterFromLocalStorageV1()

  return (
    <SurveyFilterInformation
      className={className}
      filterGroups={surveyFilter?.filterGroups}
      sampleSize={sampleSize}
      surveyId={surveyId}
      onChange={setSurveyFilter}
      onReady={setSurveyFilterFromLocalStorageV1}
    />
  )
}
